<template>
  <div class="floor">
    <a class="btnWnd btnWndClose" href="javascript:;" @click="fnWndClose">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="10px"
        height="10px"
      >
        <path
          fill-rule="evenodd"
          fill="rgb(136, 136, 136)"
          d="M8.000,6.000 L8.000,7.000 L9.000,7.000 L9.000,8.000 L10.000,8.000 L10.000,10.000 L8.000,10.000 L8.000,9.000 L7.000,9.000 L7.000,8.000 L6.000,8.000 L6.000,7.000 L4.000,7.000 L4.000,8.000 L3.000,8.000 L3.000,9.000 L2.000,9.000 L2.000,10.000 L-0.000,10.000 L-0.000,8.000 L1.000,8.000 L1.000,7.000 L2.000,7.000 L2.000,6.000 L3.000,6.000 L3.000,4.000 L2.000,4.000 L2.000,3.000 L1.000,3.000 L1.000,2.000 L-0.000,2.000 L-0.000,0.000 L2.000,0.000 L2.000,1.000 L3.000,1.000 L3.000,2.000 L4.000,2.000 L4.000,3.000 L6.000,3.000 L6.000,2.000 L7.000,2.000 L7.000,1.000 L8.000,1.000 L8.000,0.000 L10.000,0.000 L10.000,2.000 L9.000,2.000 L9.000,3.000 L8.000,3.000 L8.000,4.000 L7.000,4.000 L7.000,6.000 L8.000,6.000 Z"
        />
      </svg>
    </a>
    <div class="main" ref="main">
      <div class="frameLoginWraper">
        <div v-if="!passiveLogin">
          <div
            style="text-align: center;margin-bottom: 27px;"
            v-if="loginMethod != 'autoreg'"
          >
            <img
              src="https://account.yilewan.com/statics/authorize/logo.png"
              alt="易乐玩盒子"
            />
          </div>
          <login
            @loginResult="fnLoginResult"
            :loginMethod="loginMethod"
            @fnSwitchLoger="fnSwitchLoger"
          ></login>
        </div>
        <loading v-else />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../common/Loading'
import Login from '@/login/index'
import { encode } from 'js-base64'
export default {
  name: 'Floor',
  data() {
    return {
      USER: {
        uid: '',
        passport: ''
      },
      pageTitle: '易乐玩盒子',
      isLogined: false,
      frameLoginSrc: '',
      frameLoginUrl:
        location.protocol +
        '//account.yilewan.com/statics/authorize/#/floor?floor=1',
      gameCode: '',
      gameBg: '',
      startRecordTimer: null,
      endRecordTimer: null,
      passiveLogin: true,
      btnSwitchLoger: 1,
      loginMethod: 'methods'
    }
  },
  components: {
    Login,
    Loading
  },
  beforeCreate() {
    localStorage.setItem('startRecordTimer', Date.now())
  },
  mounted() {
    let t = this
    t.$cookies.set(
      'jsGameCode',
      t.$route.params.id,
      '24h',
      '/',
      location.host.substr(location.host.indexOf('.'))
    )
    t.clientVersion =
      typeof window.clientInfo === 'string'
        ? JSON.parse(window.clientInfo).client_version
        : window.clientInfo
    t.fnSetPidCookies()
    // 获取传入PID参数
    console.log('GetCommandParams111111')
    t.fnCefGameBox({
      method: 'GetCommandParams',
      success: res => {
        console.log('GetCommandParams')
        console.log(res)
        let param = res.param || res.data.param
        if (res && param) {
          if (param.indexOf('--extend=') < 0) return
          let s = param.split('--extend=')[1]
          s = s.split('&')
          let n = param.split(' ')
          console.log(param)
          console.log(s)
          for (let j = 0; j < n.length; j++) {
            if (n[j].indexOf('gameurl=') > -1) {
              t.gameUrl = n[j]
                .split('=')[1]
                .replace('"', '')
                .replace('box.yilewan.com', 'pcbox.yilewan.com/home')

              if (t.clientVersion[0] === '2') {
                new Image(1, 1).src =
                  'https://gppt.stnts.com/public/upload/boxv1.jpg'
                location.href = t.gameUrl
              }
            }
          }
          for (let i = 0; i < s.length; i++) {
            if (s[i].indexOf('pid=') > -1) {
              let jspid = s[i].split('=')[1].replace('"', '')
              t.$cookies.set(
                'jspid',
                jspid,
                '24h',
                '/',
                location.host.substr(location.host.indexOf('.'))
              )
              t.$cookies.set(
                'pid',
                jspid,
                '24h',
                '/',
                location.host.substr(location.host.indexOf('.'))
              )
              t.fnSetPidCookies()
              t.Storage.set('jspid', jspid, r => {})
            }
            if (s[i].indexOf('gamebg=') > -1) {
              t.gameBg = s[i].split('=')[1].replace('"', '')
              t.$refs.main.style.background =
                'url(' + t.gameBg + ') no-repeat left 0'
            }
            if (s[i].indexOf('gameurl=') > -1) {
              t.gameUrl = s[i]
                .split('=')[1]
                .replace('"', '')
                .replace('box.yilewan.com', 'pcbox.yilewan.com/home')

              alert(t.gameUrl)
              if (t.clientVersion[0] === '2') {
                new Image(1, 1).src =
                  'https://gppt.stnts.com/public/upload/boxv1.jpg'
                location.href = t.gameUrl
              }
            }
            if (s[i].indexOf('isVisor=') > -1) {
              let isVisor = s[i].split('=')[1].replace('"', '')
              t.loginMethod = parseInt(isVisor) ? 'autoreg' : 'methods'
              t.Storage.set('isVisor', isVisor, r => {})
            }
          }
        }
        t.checkPidSwitch()
      }
    })
    // 设置Floor信息
    t.$cookies.set(
      'jsFloor',
      t.$route.params.id,
      '24h',
      '/',
      location.host.substr(location.host.indexOf('.'))
    )
    // 设置落地页登录地址
    t.frameLoginSrc = t.frameLoginUrl
    // 获取用户信息
    t.Storage.get('USER', res => {
      if (res.data.USER) {
        t.USER = res.data.USER
        t.isLogined = true
      }
    })
    // 添加消息事件监听

    // client call javascript
    window.CCJS = t.CCJS
    // 获取链接参数
    t.gameCode = t.$route.params.id
    t.fnGetGamePlayInfo()
    t.$nextTick(() => {
      if (t.clientVersion[0] === '1') {
        t.fnChecking()
      }
      t.endRecordTimer = Date.now()
      t.DSP.pv({
        opentime:
          Number(t.endRecordTimer) -
          Number(localStorage.getItem('startRecordTimer')),
        uid: t.USER.uid
      })
    })
  },
  methods: {
    // 落地页登录成功后事件处理
    fnLoginResult(o) {
      let t = this
      t.fnCefGameBox({
        method: 'FlushCookies',
        success: r => {
          t.fnCefGameBox({
            method: 'SendJsMsg',
            data: {
              method: 'floorCallReload',
              data: {
                token: o.box_token
              }
            }
          })
        }
      })
      t.USER = o
      t.fnGetGameUrl()
    },
    // 检测登录态
    fnChecking() {
      ELSDK.SDKAPI('checkLogin', {}, res => {
        if (res.status === 'error') {
          this.fnLogout(true)
          this.passiveLogin = false
          return
        }
        this.fnGetYilewanToken()
        this.passiveLogin = true
      })
    },
    // 获取yilewan_token
    fnGetYilewanToken() {
      let t = this
      // eslint-disable-next-line
      ELSDK.SDKAPI('ylwtoken', {}, res => {
        if (res.status === 'error') {
          t.Toast({ content: res.msg })
          return
        }
        let d = res.data
        this.fnBoxLogin(d)
      })
    },
    // 盒子登录
    fnBoxLogin(d) {
      let t = this
      t.XHR({
        url: t.ports.user.login,
        data: {
          yilewan_token: d.token,
          uid: d.uid
        },
        cbFn(res) {
          if (res.status === 'error') {
            t.Toast({
              content: res.info,
              time: 5000
            })
            return
          }
          t.$store.commit('FNSTATE', {
            USER: res.data
          })
          t.USER = res.data
          t.fnCefGameBox({
            method: 'FlushCookies',
            success: r => {
              t.fnCefGameBox({
                method: 'SendJsMsg',
                data: {
                  method: 'floorCallReload',
                  data: {
                    token: d.token
                  }
                }
              })
            }
          })
          if (parseInt(t.$cookies.get('isFirst'))) {
            t.DSP.login({
              uid: res.data.uid,
              passport: res.data.passport,
              login_type: 2
            })
            t.$cookies.remove('isFirst', '/', '.yilewan.com')
          }
          let loginType = 1
          if (t.$cookies.get('login_type') === 'phone') {
            loginType = 2
          }
          if (t.$cookies.get('login_type') === 'qq') {
            loginType = 3
          }
          if (t.$cookies.get('login_type') === 'weixin') {
            loginType = 5
          }
          if (t.$cookies.get('login_type') === 'weibo') {
            loginType = 4
          }
          t.DSP.login({
            dataType: 'login',
            uid: res.data.uid,
            passport: res.data.passport,
            type: loginType,
            login_type: 2,
            game: t.$route.params.id
          })
          ELSDK.SDKAPI(
            'tjlogin',
            {
              uid: res.data.uid,
              source_page: 'yilewan_pcbox',
              attr: t.$cookies.get('jsGameCode') ? 'game' : '',
              attr_value: t.$cookies.get('jsGameCode')
                ? t.$cookies.get('jsGameCode')
                : ''
            },
            res => {}
          )
          t.$cookies.remove('login_type')
          // 写入用户信息.
          t.Storage.set('USER', res.data, j => {
            t.wndLogin = false
            t.wndThirdLogin = false
            t.isLogined = true
            t.fnGetGameUrl()
          })
        }
      })
    },
    // 获取游戏地址
    fnGetGameUrl() {
      this.XHR({
        url: this.ports.game.quick,
        data: {
          game_code: this.gameCode
        },
        cbFn: res => {
          if (res.status === 'error') {
            this.Toast({
              content: res.info
            })
            return
          }
          this.$cookies.set(
            'jsGameServer',
            res.data.server_id,
            '24h',
            '/',
            location.host.substr(location.host.indexOf('.'))
          )
          this.Storage.set(
            'floor' + this.$route.params.id.toLowerCase(),
            this.$route.params.id.toLowerCase()
          )
          // if (res.data.identify && res.data.game_type === 1 && !this.USER.isVistor) {
          //     this.XHR({
          //         url: this.ports.user.isIdentify,
          //         config: { withCredentials: true },
          //         cbFn: res_ => {
          //             if (res_.status === 'error') {
          //                 this.Toast({
          //                     content: res_.info
          //                 })
          //                 return
          //             }
          //             if (res_.data && !res_.data.identificationCard) {
          //                 res.data.core_type = 0
          //                 res.data.play_url = location.protocol + '//box.yilewan.com/#/gamePlay?url=' + encodeURIComponent('http://account.yilewan.com/statics/certification/pcreal.html') + '&gameidentify=' + res.data.identify
          //             }
          //             this.fnOpenGame(res.data)
          //         }
          //     })
          // } else {
          //     this.fnOpenGame(res.data)
          // }
          this.fnOpenGame(res.data)
        }
      })
    },
    fnOpenGame(res) {
      let title = ''
      if (res.game_name) {
        title += res.game_name + ' | '
      }
      if (res.server_name) {
        title += res.server_name + ' | '
      }
      if (this.USER.passport && !this.USER.isVistor) {
        title += this.USER.passport
      }

      let d = {
        url: res.play_url,
        width: 1400,
        height: 840,
        type: res.core_type,
        window_title: title || '易乐玩游戏盒子',
        game_name: res.game_name,
        game_code: res.game_code,
        server_name: res.server_name,
        server_id: res.server_id,
        passport: this.USER.passport,
        uid: this.USER.uid
      }
      if (res.game_type === 4 && res.orientation) {
        d.width = 500
        d.height = 819
      }
      if (res.core_type === 2 && res.game_type === 1 && this.USER.isVistor) {
        d.url =
          'http://box.yilewan.com/webGame.html?url=' +
          encodeURIComponent(res.play_url)
      }
      if (res.game_type !== 4) {
        d.url =
          'https://box-api.yilewan.com/accessGame/playTo?url=' +
          Base64.encode(d.url) +
          '&uid=' +
          this.USER.uid +
          '&game_code=' +
          res.game_code +
          '&passport=' +
          this.USER.passport
      }
      this.fnCefGameBox({
        method: 'clientOpenWnd',
        data: d,
        success: j => {
          // this.fnWndClose()
          this.fnGoHall()
        }
      })
    },
    // 退出登录
    fnLogout(hideToast) {
      let t = this
      t.XHR({
        url: t.ports.user.logout,
        cbFn: res => {
          if (!hideToast) t.Toast({ content: res.info })
          if (res.status === 'error') return false
          // t.fnClearLoginInfo()
        }
      })
    },
    // client call javascript
    CCJS(e) {
      if (e.method === 'wndBlank') {
        this.fnCefGameBox({
          method: 'SendJsMsg',
          data: {
            method: 'wndBrowser',
            data: {
              url: e.url
            }
          }
        })
      }
    },
    fnGoHall() {
      this.fnCefGameBox({
        method: 'clientWndClose'
      })
      // location.href = 'https://box.yilewan.com/'
    },
    // 关闭窗口
    fnWndClose() {
      let t = this
      t.fnCefGameBox({
        method: 'SendJsMsg',
        data: {
          method: 'wndCloseFloor'
        },
        success() {
          t.fnCefGameBox({
            method: 'clientWndClose'
          })
        }
      })
    },
    // 获取游戏地址
    fnGetGamePlayInfo() {
      let t = this
      t.$refs.main.style.background = 'url(' + t.gameBg + ') no-repeat left 0'
      t.XHR({
        url: t.ports.game.launch,
        data: {
          game_code: t.gameCode,
          token: t.USER.box_token || ''
        },
        cbFn: res => {
          if (res.status === 'error') {
            t.Toast({
              content: res.info
            })
            return
          }
          t.pageTitle = res.data.game_name
          t.$refs.main.style.background = t.gameBg
            ? 'url(' + t.gameBg + ') no-repeat left 0'
            : 'url(' + res.data.img + ') no-repeat left 0'
        }
      })
    },
    // 打开游戏
    fnPlayGame(o) {
      this.fnCefGameBox({
        method: 'clientOpenWnd',
        data: o,
        success: res => {
          this.Storage.set('floor' + this.$route.params.id.toLowerCase())
          this.fnGoHall()
          // this.fnWndClose()
        }
      })
    },
    // 消息监听
    fnEventListener() {
      window.addEventListener('message', this.fnMsgEvent, false)
    },
    // 添加PID
    fnAddPid(u) {
      let pid = this.$cookies.get('jspid') || ''
      let s = ''
      let uu = ''
      if (u.indexOf('#') > -1) {
        uu = u.split('#')
        u = uu[0]
        s = uu[1]
      }
      if (pid && u.indexOf('pid=') < 0) {
        if (u.indexOf('?') > -1) {
          u = u + '&pid=' + pid
        } else {
          u = u + '?pid=' + pid
        }
      }
      if (u.indexOf('?') > -1) {
        u += '&path=' + s
      } else {
        u += '?path=' + s
      }
      return u
    },
    // 设置PID-COOKIES
    fnSetPidCookies() {
      let t = this
      let showurl = location.href
      t.$cookies.set(
        'showurl',
        t.fnAddPid(showurl),
        '24h',
        '/',
        location.host.substr(location.host.indexOf('.'))
      )
      t.$cookies.set(
        'referrer',
        t.fnAddPid(document.referrer || showurl),
        '24h',
        '/',
        location.host.substr(location.host.indexOf('.'))
      )
    },
    fnSwitchLoger(type) {
      this.loginMethod = type
    }
  }
}
</script>

<style lang="less" scoped>
.floor {
  height: 100%;
}
.main {
  height: 100%;
  background-position: center 0;
  background-repeat: no-repeat;
  background: #000;
  -webkit-app-region: drag;
}
.btnWndClose {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 9;
}
.thirdLoginIframe {
  -webkit-app-region: no-drag;
}
.frameLoginWraper {
  width: 380px;
  height: 100%;
  padding: 30px 40px;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  -webkit-app-region: no-drag;
  .iframe {
    width: 100%;
    height: 100%;
    margin-top: 15px;
  }
}
</style>
